import { usePayments } from '../../../../api/hooks/sales/usePayments';
import { useConsultants } from '../../../../api/hooks/sales/useConsultants';
import { EntityTable } from '../../../common/entity-table/EntityTable';
import { getPaymentColumnDefinition, PAYMENT_TABS } from '../../../../schema/sales/payments.schema';

export const PaymentsPanel = () => {
  const paymentsQuery = usePayments();
  const { consultants } = useConsultants();

  return (
    <EntityTable
      query={paymentsQuery}
      getColumnDefinition={getPaymentColumnDefinition}
      entityTabs={PAYMENT_TABS(consultants)}
      entityName="Payment"
      canView={false}
      canExport={true}
    />
  );
};
